import React, { useState, useEffect, useCallback, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Icon, Tooltip, Menu, Dropdown, message, Button, Alert } from 'antd';
import { HeaderText, ListContainer } from '../../SidebarMenu/styles';
import { ENTERPRISE_ENV, EXISTING_CHANNELS } from '../../../utils/helper';
import { CHANNEL_SIDEBAR_TAB as trans } from './translationValues';
import { TEMPLATE_TRANSLATION as translation } from '../TranslateTab/translationValues';
import { TickIcon, ChangeIcon } from '../../../images/svgIcons';
import { getAllLanguage } from '../../../utils/services/languageApi';
import { getChannels as getChannelGroup, getConsolidateVariableContract,} from '../../../utils/services/channelAPI';
import { deleteComplexDocument, changeLanguage, translateComplexDocument } from '../../../utils/services/complexDocumentsAPI';
import { translateEmailTemplate, deleteComplexMailTemplate } from '../../../utils/services/complexEmailAPI';
import { translateTemplate as translateShortMessageTemplate, deleteShortMessageTemplate } from '../../../utils/services/shortMessageTemplateAPI';
import { useArtboardContext, CONTEXT_KEYS } from '../../../context/complexArtboardContext';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext, useComplexDocumentHistory } from '../../../context/complexDocumentContext';
import { useSessionContext } from '../../../context/sessionContext';
import CreateTemplateModal from '../../../components/CreateNewTemplate/CreateTemplateModal';
import CreateShortMsgTempModal from '../../../components/CreateNewTemplate/CreateShortMsgTempModal';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import CreateMailTemplateModal from '../../../components/CreateNewTemplate/CreateMailTemplateModal';
import FilterPanel from './FilterPanel';
import { DownloadButton } from '../styles';
import { uploadEnvDataSet } from '../../../utils/services/documentAPI';
import { checkFileFormat, getPayloadFromFile, processFile } from '../../../utils/transactionHelpers';
import { envs } from '../../../utils/complexDocumentConstants';
import { parseFileWithKnownDelimiters, generatePayloadFromCsvFile } from '../../../utils/helper';
import { TRANSACTIONS } from '../../TemplateSection/translationValues';

const NAMESPACES = ['CHANNEL_SIDEBAR_TAB', 'TEMPLATE_TRANSLATION','TEMPLATE_PREVIEW_MODAL', 'TRANSACTIONS'];


const CommunicationTab = (props) => {
  const { t, currentId, currentType = EXISTING_CHANNELS[0].key, categoryId=undefined, resourceGroupId=undefined, shortMsgGroupId=undefined } = props;
  const  isSavingChangesSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_SAVING_CHANGES], []);
    const [isSavingChanges] = useDocumentContext(isSavingChangesSelector, `ComplexArtboardSidebar`);
  const [expand, setExpand] = useState([]);

  const [openTabs, setOpenTabs] = useState([currentType]);
  const [channelDetails, setChannelDetails] = useState(undefined);
  const [allLanguages, setAllLanguages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);
  const [deleteTemplate, setDeleteTemplate] = useState(undefined);
  const [changeLanguageOptions, setChangeLanguageOptions] = useState([]);
  const [createTemplateModal, setCreateTemplateModal] = useState(null);
  const [panelKey, setPanelKey] = useState(0);
  const [loading, setLoading] = useState(false);

  const templateRef = useRef(null);
  const fileRef = useRef(null);
  const history = useHistory();

  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [organisationDetails] = useSessionContext(organisationSelector);

  const documentIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID], []);
  const [documentId] = useDocumentContext(documentIdSelector, `CommunicationTab`);

  const commIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.COMMUNICATION_ID], []);
  const [documentCommunicationId] = useDocumentContext(commIdSelector, `CommunicationTab`);

  const contextSelector = useCallback(store => store, []);
  const [documentContext, methods] = useDocumentContext(contextSelector); // TODO : Change this to specific keys to avoid rerendering

  const dummyCallback = useCallback(store => undefined, []);
  const [,updateArtboard] = useArtboardContext(dummyCallback);

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const category_Id = currentType === 'short_message'? categoryId : documentContext.categoryId;
  const resourceGroup_Id = currentType === 'short_message'? resourceGroupId : documentContext.resourceGroupId
  const communicationId = currentType === 'short_message'? shortMsgGroupId : documentCommunicationId

  useEffect(() => {
    (async () => {
      const response = await getAllLanguage();
      if (response.data) setAllLanguages(response.data);
    })();
  }, []);

  const getChannelDetails = useCallback(async (currentGroupId, currentType, noReload = false) => {
    console.log("getChannelDetails called :: ", currentGroupId, currentType);
    if (!noReload) setIsLoading(true);
    const response = await getChannelGroup(currentGroupId, currentType);
    console.log({ response });
    if (response) setChannelDetails(response);
    if (!noReload) setIsLoading(false);
    setTimeout(() => {
      const allListItems = document.querySelectorAll(`.${currentType}.animate`);
      Array.from(allListItems).forEach(listItem => {
        listItem.style['pointer-events'] = 'all';
      })
    }, 100);
  }, []);

  useEffect(() => {
    if (communicationId) {
      getChannelDetails(communicationId, currentType);
    }
  }, [communicationId, currentType]);

  const replaceTranslation = useCallback(async (data) => {
    const payload = {
      "id": currentId,
      "language": {
        "code": data.code,
        "name": data.name,
      },
      "type": currentType
    }
    const response = await changeLanguage(payload);
    methods.set({
      [COMPLEX_DOCUMENT_CONTEXT_KEYS.LANGUAGE]: data.code
    });

    if (response.statusCode === 1930) {
      message.success(t(`TEMPLATE_TRANSLATION:${translation.LANGUAGES_UPDATE_SUCCESS_LABEL.key}`, translation.LANGUAGES_UPDATE_SUCCESS_LABEL.value));
      getChannelDetails(communicationId, currentType, true);
    } else {
      message.error(t(`TEMPLATE_TRANSLATION:${translation.UPDATE_LANGUAGE_ERROR_MESSAGE.key}`, translation.UPDATE_LANGUAGE_ERROR_MESSAGE.value))
    }
  }, [currentId, communicationId, currentType]);

  useEffect(() => {
    if (channelDetails && allLanguages) {
      console.log({ allLanguages, channelDetails });
      const translatedTemplates = channelDetails.mappedChannels?.find(channel => channel.type === currentType)?.templates || [];
      const notTranslated = allLanguages.filter(i => {
        return !translatedTemplates.some(j => j.lang === i.code);
      });
      setChangeLanguageOptions(notTranslated);
    }
  }, [allLanguages, channelDetails]);


  const getFlatFilesPayload = async (data, templateVariables,communicationId) => {
    const payload = generatePayloadFromCsvFile(data, templateVariables, 'communication', communicationId);
    return payload;
  }

  const bulkUpload = async (requests, envType) => {
    if (requests && envType) {
      try {
        const response = await uploadEnvDataSet(envType, requests);
        if (response.statusCode === 200) {
          message.success(t(
            trans.UPLOAD_SUCCESS_MESSAGE.key,
            trans.UPLOAD_SUCCESS_MESSAGE.value,
          ))
        }
        else {
          message.error(t(
            trans.UPLOAD_FAILURE_MESSAGE.key,
            trans.UPLOAD_FAILURE_MESSAGE.value,
          ))
        }
      }
      catch {
        message.error(t(
          trans.UPLOAD_FAILURE_MESSAGE.key,
          trans.UPLOAD_FAILURE_MESSAGE.value,
        ))
      }
      finally {
        setLoading(false);
      }
    }
    else {
      setLoading(false);
      return;
    }
  }

  const onImportFile = useCallback(async e => {
    setLoading(true);
    const file = e.target.files[0];
    let requests;
    if (file) {
      e.target.value = '';
      const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type;
      if (fileFormat === 'text/plain' || fileFormat === 'text/csv') {
        const { data, delimiter } = await parseFileWithKnownDelimiters(file);
        if (!data.env) {
          message.error(t(
            trans.INVALID_ENV.key,
            trans.INVALID_ENV.value,
          ))
          return;
        }
        const envFromFile = fileFormat === 'text/csv' ? data?.env?.split(',').map(v => v.trim()).filter(Boolean)[0] : data?.env;
        const envValue = envFromFile.split('=')
        let response;
        try {
          const payload = {
            communicationId: channelDetails?.communicationId,
          };
          response = await getConsolidateVariableContract(payload, envValue[1]);
        } catch (error) {
          setLoading(false);
        }
        if (response && response?.data?.variableContract.length > 0  && data?.results.length > 0) {
          const templateVariables = response.data.variableContract
          const payload = await getFlatFilesPayload(data?.results, templateVariables, channelDetails?.communicationId);
          if (payload && payload.length > 0) {
            bulkUpload(payload, envValue[1]);
          }
        }
        else{
          message.error(
            t(
              TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key,
              TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
            ),
          );
        }
        return;
      }
    }
    const reader = new FileReader();
    reader.onload = async event => {
      const binaryString = event.target.result;
      const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type
      const { envType } = processFile(fileFormat, binaryString,t);      
      if (!envs.includes(envType)) {
        setLoading(false);
        message.error(t(
          trans.INVALID_ENV.key,
          trans.INVALID_ENV.value,
        ))
        return;
      }
      let response = null;
      let template;

      try {
        const payload = {
          communicationId: channelDetails?.communicationId,
        };
        response = await getConsolidateVariableContract(payload, envType);
      } catch (error) {
        setLoading(false);
        console.error(error);
      }

      if (response && response.data) {
        template = {
          variableContract: response.data.variableContract,
          passwordProtected: response.data.passwordProtected,
          communicationId: communicationId,
          id: null,
        };
        requests = getPayloadFromFile(binaryString, file, template, t, false, false, undefined, true, true);
      }
        bulkUpload(requests,envType);
    }
  if (file.type === 'application/json' || file.type === 'application/xml' || file.type === 'text/xml') {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
    e.target.value = '';
  },[channelDetails]);

  const menu = (
    <Menu>
      {changeLanguageOptions.map((list) => (
        <Menu.Item onClick={() => replaceTranslation(list)}>
          <span>{list.name}</span>
        </Menu.Item>
      ))}
    </Menu>
  );

  const fetchData = useCallback(async (toSet) => {

    setExpand((previousValue) => {
      if (previousValue.includes(toSet)) {
        return previousValue.filter(e => e !== toSet);
      }
      return [...previousValue, toSet];
    });
  }, [allLanguages, channelDetails]);

  const [, historyStore] = useComplexDocumentHistory(store => store.history);
  const handleRedirection = useCallback((type, id, channelTab = false) => {
    switch(type) {
      case 'document':
        history.push(`/design/${id}`, channelTab && { tabIndex: 14 });
        historyStore.set({ action: 'clearAll'});
        break;
      case 'email':
        history.push(`/complexEmailDesign/${id}`, channelTab && { tabIndex: 15 });
        break;
      case 'short_message':
        history.push(`/shortMessageDesign/${id}`, channelTab && { tabIndex: 21 });
        break;
      default:
        return;
    }
  }, []);

  const handleTemplateCreation = useCallback(async ({ id, documentId, templateId, name = undefined }) => {
    // TODO : Ensure this method is called only on successful template creation
    getChannelDetails(communicationId, currentType);
        message.success(t(trans.LINK_SUCCESS_MESSAGE.key, trans.LINK_SUCCESS_MESSAGE.value, {
          targetType: createTemplateModal.replaceAll('_', ' '),
          currentType: currentType.replaceAll('_', ' ')
        }));
        setCreateTemplateModal(null);
        handleRedirection(createTemplateModal, id || documentId || templateId);
  }, [communicationId, createTemplateModal, channelDetails, handleRedirection]);

  const handleDeletion = useCallback(async () => {
    setIsDeleting(true);
    let response;
    if (deleteTemplate.type === 'document') {
      response = await deleteComplexDocument(deleteTemplate.id);
    } else if (deleteTemplate.type === 'email') {
      response = await deleteComplexMailTemplate(deleteTemplate.id);
    }else if (deleteTemplate.type === 'short_message') {
      response = await deleteShortMessageTemplate({ id: deleteTemplate.id });
    }

    const statusCode  = [705, 1605];
    if (statusCode.includes(response?.statusCode)) {
      message.success(
        t(`TEMPLATE_TRANSLATION:${translation.TEMPLATE_DELETED_SUCCESS_MESSAGE.key}`, translation.TEMPLATE_DELETED_SUCCESS_MESSAGE.value),
      );

      getChannelDetails(communicationId, currentType, true);
    } else {
      message.error(
        t(`TEMPLATE_TRANSLATION:${translation.TEMPLATE_DELETE_ERROR_MESSAGE.key}`, translation.TEMPLATE_DELETE_ERROR_MESSAGE.value),
      );
    }
    setIsDeleting(false);
    setDeleteTemplate(undefined);
  }, [communicationId, deleteTemplate]);

  const handleTranslation = useCallback(async (data, targetChannel) => {
    console.log({ data });
    setIsTranslating(prev => ({
      ...prev,
      [data.code]: true,
    }));

    let response;
    let id = currentType === 'short_message' ? currentId : documentId;
    if (currentType !== targetChannel) {
      const channelTemplates = channelDetails.mappedChannels.find(channel => channel.type === targetChannel);
      const chosenTemplate = channelTemplates.templates[0]; // TODO : Check if the identification of primary template within group can be provided by backend
      id = chosenTemplate.id;
    }
    if (targetChannel === 'document') {
      response = await translateComplexDocument({ documentId: id, languageCode: data.code });
    } else if (targetChannel === 'email') {
      response = await translateEmailTemplate({ templateId: id, languageCode: data.code });
    }else if(targetChannel === 'short_message') {
      response = await translateShortMessageTemplate({ id, language: data.code });
    }

    const statusCode  = [725, 1617];
    if (statusCode.includes(response?.statusCode)) {
      if(ENTERPRISE_ENV && organisationDetails ? organisationDetails.languageTranslation : true) {
      message.success(
        t(
          `TEMPLATE_TRANSLATION:${translation.TEMPLATE_TRANSLATED_SUCCESS_MESSAGE.key}`,
          translation.TEMPLATE_TRANSLATED_SUCCESS_MESSAGE.value,
        ),
      );
      } else {
      handleRedirection(currentType, response?.data?.id);
      message.success(
        t(
          `TEMPLATE_TRANSLATION:${translation.TEMPLATE_CREATED_SUCCESS_MESSAGE.key}`,
          translation.TEMPLATE_CREATED_SUCCESS_MESSAGE.value,
        ),
      );
      }

      const newLanguage = {
        id: response.data.id,
        language: data.code,
      };

      // TODO : Change channel details to include new language
      getChannelDetails(communicationId, currentType, true);
    } else if (response?.errors?.some(error => error?.code === 1702)) {
      message.warn(t(`TEMPLATE_TRANSLATION:${translation.TRANSLATION_LIMIT_EXCEEDED_WARNING.key}`, translation.TRANSLATION_LIMIT_EXCEEDED_WARNING.value));
      const { planName, languageCharacter } = userDetails.planMapping;
      // TODO : New namespace add
      updateArtboard({
        [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {
          visible: true,
          message:
            planName === 'Premium'
              ? t(`TEMPLATE_TRANSLATION:${translation.PREMIUM_PLAN_LIMIT_EXCEEDED_ERROR.key}`,
                translation.PREMIUM_PLAN_LIMIT_EXCEEDED_ERROR.value, { emailId: 'support@perfectdoc.studio' })
              : planName === 'Free'
              ? t(`TEMPLATE_TRANSLATION:${translation.FREE_PLAN_UPGRADE_MESSAGE.key}`,
                translation.FREE_PLAN_UPGRADE_MESSAGE.value)
              : t(`TEMPLATE_TRANSLATION:${translation.STANDARD_PLAN_UPGRADE_MESSAGE.key}`,
                translation.STANDARD_PLAN_UPGRADE_MESSAGE.value, { languageCharacter }),
        },
      });
    } else if(response?.errors?.some(error => error?.code === 2422)) {
      message.error(t(`TEMPLATE_TRANSLATION:${translation.DOCUMENT_CREATION_LIMIT_EXCEEDED_ERROR.key}`, translation.DOCUMENT_CREATION_LIMIT_EXCEEDED_ERROR.value));
    } else {
      if(ENTERPRISE_ENV && organisationDetails ? organisationDetails.languageTranslation : true) {
        message.error(
          t(
            `TEMPLATE_TRANSLATION:${translation.TEMPLATE_TRANSLATE_ERROR_MESSAGE.key}`,
            translation.TEMPLATE_TRANSLATE_ERROR_MESSAGE.value,
          ),
        );
      } else {
        message.error(t(
          `TEMPLATE_TRANSLATION:${translation.TEMPLATE_CREATION_ERROR_MESSAGE.key}`, translation.TEMPLATE_CREATION_ERROR_MESSAGE.value,
        ));
      }
        
    }
    setIsTranslating(prev => ({
      ...prev,
      [data.code]: false,
    }));
  }, [communicationId, documentId, channelDetails, currentId, currentType]);

  const subMenu = (key) => {
    let translatedTemplates = channelDetails.mappedChannels.find(channel => channel.type === key)?.templates || [];
    translatedTemplates = translatedTemplates.map(mapping => Object.assign({}, mapping, {
      parentTemplateId: translatedTemplates[0].id
    }));
    const notTranslated = allLanguages.filter(i => {
      return !translatedTemplates.some(j => j.lang === i.code);
    });
    if (notTranslated.length > 0) {
      return (
            <ul className={`${key} collapse ${openTabs.includes(key) && expand?.includes(key) ? 'show' : 'hide'}`}>
              {notTranslated.map(data => (
                <li key={data.code} value={data.code} onClick={e => e.stopPropagation()}>
                  <span>{data.name}</span>
                  {(ENTERPRISE_ENV && organisationDetails ? organisationDetails.languageTranslation : true) ?
                  <Button
                    icon="plus"
                    loading={isTranslating[data.code]}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTranslation(data, key);
                    }}
                  >
                    {t(translation.TRANSLATE_BUTTON.key, translation.TRANSLATE_BUTTON.value)}
                  </Button>
                  : isTranslating[data.code] 
                    ? <Icon type="loading" /> : 
                    <Icon type="plus" onClick={() => {
                      handleTranslation(data, key);
                    }} />
                  }
                </li>
              ))}
            </ul>
        );
    } else {
      return <div />
    }
  }

  const renderChannelDetails = (channel) => {
    if (isLoading || allLanguages?.length === 0) {
      return (
      <li
        key={channel.key}
        value={channel.key}
        style={{ justifyContent:'space-between', paddingLeft: 30 }}
      >
        <span style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 'bold' }}>
          {t(trans[channel.translateKey].key, trans[channel.translateKey].value)}
        </span>
      </li>
      );
    }
    const details = channelDetails?.mappedChannels?.find(e => e.type === channel.key);
    return (
    <>
    <li
      key={channel.key}
      value={channel.key}
      style={{ justifyContent:'space-between', paddingLeft: details?.templates?.length > 0 ? 10 : 30 }}
      active={openTabs.includes(channel.key)}
      onClick={e => {
        e.stopPropagation();
        if (details?.templates?.length > 0) {
          setOpenTabs((previousValue) => {
            let remove = previousValue.includes(channel.key);
            if (remove) {
              const allListItems = document.querySelectorAll(`.${channel.key}.animate`);
              Array.from(allListItems).forEach(listItem => {
                listItem.style['pointer-events'] = 'none';
              })
              setExpand((expandValue) => {
                return expandValue.filter(e => e !== channel.key);
              });
              return previousValue.filter(openTab => openTab !== channel.key);
            }
            setTimeout(() => {
              const allListItems = document.querySelectorAll(`.${channel.key}.animate`);
              Array.from(allListItems).forEach(listItem => {
                listItem.style['pointer-events'] = 'all';
              })
            }, 1000);
            return [...previousValue, channel.key];
          });
        }
      }}
    >
      <span style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 'bold' }}>
        {details?.templates?.length > 0 && (<span
          style={{ display: 'inline-block', marginRight: 10, cursor: 'pointer', fontSize: 12,
          transform: openTabs.includes(channel.key) ? 'rotate(90deg)' : 'none', transition: 'all 0.4s ease-in' }}
        >
          <Icon type="right" />
        </span>)}
        {t(trans[channel.translateKey].key, trans[channel.translateKey].value)}
      </span>
      {(details === undefined) && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent:"center",columnGap:"10px" }}>
          <Tooltip title={t(trans.CREATE_NEW_TEMPLATE_TOOLTIP.key, trans.CREATE_NEW_TEMPLATE_TOOLTIP.value, { type: channel.key.replaceAll('_', ' ') })}>
            <Icon type="plus" onClick={() => {
              templateRef.current = { name: channelDetails.communicationName };
              setCreateTemplateModal(channel.key)}
            } />
          </Tooltip>
        </div>
      )}
    </li>
    <ul className={`${channel.key} animate ${openTabs.includes(channel.key) ? 'show' : 'hide'} ${isSavingChanges? 'disabled' : ''}`}>
      {allLanguages && details?.templates && details?.templates?.map(template => {
        if (!template.lang) {
          return (
              <li
                style={{ paddingLeft: 40, justifyContent: 'space-between' }}
                className={'enableHover'}
                onClick={() => handleRedirection(details.type, template?.id, true)}
              >
                <span style={{ fontSize: 12, textTransform: 'uppercase' }}>
                  Yet to detect {/* TODO : Need namespace add */}
                </span>
                {`${currentId}` === `${template.id}` && (
                  <span
                    onClick={e => {
                      e.stopPropagation();
                    }}
                  >
                    {/* <TickIcon /> */}
                    <Tooltip title={t(trans.ASSIGN_LANGUAGE_TOOLTIP.key, trans.ASSIGN_LANGUAGE_TOOLTIP.value)}>
                      <Dropdown
                        overlay={menu}
                        trigger={['click']}
                        overlayClassName="complex-channels-tab-dropdown"
                        getPopupContainer={() => document.getElementById('channel-tab')}
                        onVisibleChange={() => {
                          // Issue with first scroll within dropdown - Effect to remove the glitch
                          setTimeout(() => {
                            const dropdownMenu = document.querySelector('.ant-dropdown');
                            dropdownMenu.scrollTo(0, 1);
                          }, 0);
                        }}
                      >
                        <Icon component={ChangeIcon} className="changeIcon" />
                      </Dropdown>
                    </Tooltip>
                  </span>
                )}
              </li>
          )
        }
        const language = allLanguages.find(lang => lang.code === template.lang);
        return (
          <li
            style={{ paddingLeft: 40 }}
            className={'enableHover'}
            onClick={() => handleRedirection(details.type, template?.id, true)}
          >
            <span> {language.name} </span>
              {(`${currentId}` === `${template.id}`) && (<span
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center",columnGap:"10px" }}>
                  <TickIcon />
                  {changeLanguageOptions.length > 0 && (
                  <Dropdown
                    overlay={menu}
                    autoAdjustOverflow={false}
                    trigger={['click']}
                    overlayClassName="complex-channels-tab-dropdown"
                    getPopupContainer={() => document.getElementById('channel-tab')}
                    onVisibleChange={() => {
                      // Issue with first scroll within dropdown - Effect to remove the glitch
                      setTimeout(() => {
                        const dropdownMenu = document.querySelector('.ant-dropdown');
                        dropdownMenu.scrollTo(0, 1);
                      }, 0);
                    }}
                  >
                    <Icon component={ChangeIcon} className='changeIcon' />
                  </Dropdown>)}
                 </div>
              </span>)}
              {(`${currentId}` !== `${template.id}`) && (<span
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center",columnGap:"10px" }}>
                  <Icon type="delete" onClick={() => {
                    setDeleteTemplate({ id: template.id, type: channel.key });
                  }} />
                </div>
              </span>)}
          </li>
        )
      })}
      {details?.templates && details?.templates.findIndex(temp => temp.lang == null) === -1
        && (details?.templates?.length < allLanguages.length) && (<li
        style={{ flexDirection: 'column', alignItems: 'flex-start' }}
        onClick={e => {
         e.stopPropagation();
         fetchData(expand === channel.key ? undefined : channel.key);
       }}
      >
      <span style={{ fontStyle: 'italic' }}>
        <span
          style={{ display: 'inline-block', marginRight: 10, cursor: 'pointer', fontSize: 12,
          transform: expand.includes(channel.key) ? 'rotate(90deg)' : 'none', transition: 'all 0.4s ease-in' }}
        >
          <Icon type="right" />
        </span>
        More Languages
      </span>
    </li>)}
    </ul>
    {details?.templates && details?.templates.findIndex(temp => temp.lang == null) === -1
             && (details?.templates?.length < allLanguages.length) && subMenu(channel.key)}
    </>);
  }

  if (!isLoading && !channelDetails.communicationId) {
    return (
      <div style={{ marginTop: 20 }}>
        <Alert
          /*message={t(
            trans.LANGUAGE_NOT_DETECTED_MESSAGE.key,
            trans.LANGUAGE_NOT_DETECTED_MESSAGE.value,
          )}*/
          message={"No Channel mapping found"}
          type="warning"
          showIcon
        />
      </div>
    )
  }

  const getMenu = (
    <Menu style={{marginTop:'8px'}} mode="vertical">
      <Menu.ItemGroup>
        <Menu.SubMenu
          key="1"
          title={
            <span>
              {t(
                trans.DOWNLOAD_REQUEST_SAMPLE.key,
                trans.DOWNLOAD_REQUEST_SAMPLE.value,
              )}
            </span>
          }
        >
      <div key="1">
          <FilterPanel t={t} key={panelKey} communicationId= {channelDetails?.communicationId} visible={true}/>
      </div>
      </Menu.SubMenu>
      <Menu.Item key = "2" onClick={()=>{fileRef.current.click()}}>
          <div>
            <input
              type="file"
              ref={fileRef}
              style={{ display: 'none' }}
              onInput={onImportFile}
            />
            {t(
              trans.UPLOAD_FILE.key,
              trans.UPLOAD_FILE.value,
            )}
          </div>  
      </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <div style={{ color: '#fff', overflowY: 'auto' }} id={'channel-tab'}>
      <HeaderText>
        <span>
        {t(trans.HEADING.key, trans.HEADING.value)}
        <Tooltip
          placement="right"
          title={`${t(
            trans.COPY_CHANNEL_ID_TOOLTIP.key,
            trans.COPY_CHANNEL_ID_TOOLTIP.value,
          )} (${channelDetails?.communicationId})`}
        >
          <Icon type="copy" style={{ paddingLeft: 10, cursor: 'pointer' }} onClick={() => {
            navigator.clipboard.writeText(channelDetails?.communicationId).then(() => {
              message.success(t(
                trans.COPY_SUCCESSFUL.key,
                trans.COPY_SUCCESSFUL.value,
              ));
            },() => {
              message.error(t(
                trans.COPY_FAILURE.key,
                trans.COPY_FAILURE.value,
              ));
            });
          }} />
        </Tooltip>
        </span>
        <DownloadButton channel={true} id={'more-options-download'}>
          <Dropdown
            style={{ marginTop: '8px !important' }} placement="bottomRight" overlay={getMenu} getPopupContainer={() => document.getElementById('more-options-download')}>
            <a style={{ color: 'black', textDecoration: 'none' }} onMouseEnter={() => { setPanelKey(prev => prev + 1) }} onClick={e => e.preventDefault()}>
              <span style={{ marginRight: '4px' }}>
                {t(
                  trans.BULK_GENERATE.key,
                  trans.BULK_GENERATE.value,
                )}
              </span> {loading ? <Icon type="loading" /> : <Icon type="down" />}
            </a>
          </Dropdown>
        </DownloadButton>
      </HeaderText>
      <ListContainer noHover channelTab noMargin={true}>
        <ul>
          {EXISTING_CHANNELS.map(renderChannelDetails)}
        </ul>
      </ListContainer>
      {createTemplateModal === 'document' && (
        <CreateTemplateModal
          visible={true}
          onCancel={() => {
            templateRef.current = undefined;
            setCreateTemplateModal(null);
          }}
          onSucess={handleTemplateCreation}
          selectDesign={false}
          isEmailToDoc={true}
          categoryId={category_Id}
          resourceGroupId={resourceGroup_Id}
          communicationId={channelDetails?.communicationId || undefined}
          template={templateRef.current}
        />
      )}
      {createTemplateModal === 'email' && (
        <CreateMailTemplateModal
          visible={true}
          onCancel={() => {
            templateRef.current = undefined;
            setCreateTemplateModal(null);
          }}
          onSucess={handleTemplateCreation}
          isDocToEmail={currentType === 'document' ? true : false}
          categoryId={category_Id}
          resourceGroupId={resourceGroup_Id}
          communicationId={channelDetails?.communicationId || undefined}
          template={templateRef.current}
        />
      )}
      {createTemplateModal === 'short_message' && (
          <CreateShortMsgTempModal
            visible={true}
            onCancel={() => {
              templateRef.current = undefined;
              setCreateTemplateModal(null);
            }}
            onSucess={handleTemplateCreation}
            activeContent={'whats-app'}
            categoryId={category_Id}
            resourceGroupId={resourceGroup_Id}
            communicationId={channelDetails?.communicationId || undefined}
            template={templateRef.current}
          />
      )}
      <ConfirmationModal
        visibility={deleteTemplate !== undefined}
        isLoading={isDeleting}
        onCancel={() => {
          setDeleteTemplate(undefined);
        }}
        onConfirm={handleDeletion}
        /*confirmationText={t(
          trans.TEMPLATE_DELETE_CONFIRM_MESSAGE.key,
          trans.TEMPLATE_DELETE_CONFIRM_MESSAGE.value,
        )}
        confirmButtonText={t(trans.DELETE_BUTTON.key, trans.DELETE_BUTTON.value)}*/
        confirmationText={'Are you sure if you want to delete this design?'}
        confirmButtonText={'Delete'}
        showImage={false}
      />
    </div>
  )
}

export default withTranslation(NAMESPACES)(CommunicationTab);